module.exports = __webpack_public_path__ + "img/icon_map_53_on_001.af360084.png";